import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Globe, Building2 } from 'lucide-react';
import { companyInfo, naicsCodes } from '../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_consulting-hub-14/artifacts/xuj6mki2_SSC%20Business-Trans%20BG%20Logo.png"
                alt="Skill Spectrum Consulting LLC Logo"
                className="h-8 w-auto"
              />
              <span className="text-xl font-bold">{companyInfo.name}</span>
            </div>
            <p className="text-gray-300 mb-4 max-w-md">
              {companyInfo.tagline}
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Building2 className="h-4 w-4" />
                <span>Entity ID: {companyInfo.entityId} | CAGE: {companyInfo.cageCode}</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Globe className="h-4 w-4" />
                <span>D-U-N-S: {companyInfo.dunsNumber}</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-300">
                <Mail className="h-4 w-4" />
                <a href={`mailto:${companyInfo.generalEmail}`} className="hover:text-blue-400 transition-colors">
                  {companyInfo.generalEmail}
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/business-consulting" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  H.R. & Civil Rights
                </Link>
              </li>
              <li>
                <Link to="/services/it-cybersecurity" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Cyber Security, Governance, Risk and Compliance
                </Link>
              </li>
              <li>
                <Link to="/services/design-ai" className="text-gray-300 hover:text-blue-400 transition-colors text-sm">
                  Design & AI Integration
                </Link>
              </li>
            </ul>
          </div>

          {/* NAICS Codes */}
          <div>
            <h3 className="text-lg font-semibold mb-4">NAICS Codes</h3>
            <ul className="space-y-1">
              {naicsCodes.map((naics, index) => (
                <li key={index} className="text-xs text-gray-400">
                  <span className="font-mono">{naics.code}</span>
                  <br />
                  <span>{naics.description}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              © 2026 {companyInfo.name}. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-6">
              <Link to="/contact" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">
                Contact
              </Link>
              <Link to="/about" className="text-sm text-gray-400 hover:text-blue-400 transition-colors">
                About
              </Link>
              <a 
                href={`https://${companyInfo.website}`} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="flex items-center hover:opacity-80 transition-opacity"
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_consulting-hub-14/artifacts/rl4i69ht_SSC%20Business-Trans%20BG%20Logo.png"
                  alt="Skill Spectrum Consulting LLC"
                  className="h-6 w-auto"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};